import { Link, useParams } from 'react-router-dom';
import Seo from '@/components/feature/Seo';
import { news } from '@/mocks/news';

export default function NewsDetail() {
  const { id } = useParams();
  const article = news.find((n) => n.id === id);

  if (!article) {
    return (
      <div className="mx-auto flex max-w-3xl flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-500/15 text-primary-300">
          <i className="ri-newspaper-line text-3xl"></i>
        </span>
        <h1 className="mt-5 font-heading text-xl font-bold text-foreground-950">没有找到该资讯</h1>
        <p className="mt-2 text-sm text-foreground-600">它可能已被移除，或链接有误。</p>
        <Link
          to="/news"
          className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-600"
        >
          返回资讯列表
        </Link>
      </div>
    );
  }

  const related = news.filter((n) => n.id !== article.id).slice(0, 3);

  return (
    <>
      <Seo
        title={`${article.title} - 奸情影视大全`}
        description={article.summary}
        keywords={`${article.tag},影视资讯,${article.title},奸情影视`}
      />
      <div className="mx-auto max-w-4xl px-4 py-8 md:px-6 md:py-12">
        <nav className="mb-6 flex flex-wrap items-center gap-2 text-xs text-foreground-500 md:text-sm" aria-label="面包屑导航">
          <Link to="/" className="transition-colors hover:text-foreground-950">首页</Link>
          <i className="ri-arrow-right-s-line"></i>
          <Link to="/news" className="transition-colors hover:text-foreground-950">影视资讯</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="truncate text-foreground-950">{article.title}</span>
        </nav>

        <article>
          <span className="inline-flex rounded bg-accent-500/15 px-2.5 py-1 text-xs font-medium text-accent-400">
            {article.tag}
          </span>
          <h1 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
            {article.title}
          </h1>
          <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 border-b border-background-200 pb-5 text-sm text-foreground-500">
            <span>
              <i className="ri-calendar-line mr-1"></i>
              {article.date}
            </span>
            <span>
              <i className="ri-user-line mr-1"></i>
              {article.author}
            </span>
          </div>

          <div className="my-6 overflow-hidden rounded-lg border border-background-200" style={{ height: 340 }}>
            <img
              src={article.cover}
              alt={article.title}
              title={`${article.title}资讯配图`}
              className="h-full w-full object-top"
            />
          </div>

          <div className="flex flex-col gap-5">
            {article.content.map((para, i) => (
              <p key={i} className="text-sm leading-loose text-foreground-700 md:text-base">
                {para}
              </p>
            ))}
          </div>
        </article>

        <div className="mt-10 flex flex-wrap gap-3">
          <Link
            to="/news"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-600"
          >
            <i className="ri-arrow-left-line"></i>
            返回资讯列表
          </Link>
        </div>

        <section className="mt-12">
          <div className="mb-5 flex items-center gap-3">
            <span className="h-7 w-1.5 rounded-full bg-accent-500"></span>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">相关文章推荐</h2>
          </div>
          <div className="flex flex-col gap-4">
            {related.map((item) => (
              <Link
                key={item.id}
                to={`/news/detail/${item.id}`}
                className="group flex gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-500"
              >
                <div className="h-20 w-28 shrink-0 overflow-hidden rounded-md">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title}资讯配图`}
                    className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col justify-center">
                  <p className="text-xs text-foreground-500">{item.date}</p>
                  <h3 className="mt-1 line-clamp-2 font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-300 md:text-base">
                    {item.title}
                  </h3>
                </div>
              </Link>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}